import { render, staticRenderFns } from "./dashboardTest.vue?vue&type=template&id=147880c6&"
import script from "./dashboardTest.vue?vue&type=script&lang=js&"
export * from "./dashboardTest.vue?vue&type=script&lang=js&"
import style0 from "./dashboardTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports